export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const EMAIL_STATUS = {
    SENT: 'sent',
    RECEIVED: 'received',
    DRAFT: 'draft',
    SUGGESTED: 'suggested',
    SCHEDULED: 'scheduled',
    TO_REVISE: 'to_revise',
    CANCELED: 'canceled',
    CANCELING: 'canceling',
    ERROR: 'error'
  };